import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["track", "image", "prev", "next"];
  static values = {
    slides: Number,
    total: Number
  };

  connect() {
    // Fallback: if slidesValue wasn't provided as a Stimulus value,
    // read the old data attribute (data-carousel-slides) or default to 3.
    if (!this.hasSlidesValue) {
      const attr = this.element.getAttribute("data-carousel-slides");
      this.slidesValue = parseInt(attr || "3", 10);
    }

    this.index = 0;
    this.update();

    if (this.hasTrackTarget) this.trackTarget.classList.remove("tw:invisible");
  }

  prev(event) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    if (this.index > 0) {
      this.index -= 1;
      this.update();
    }
  }

  next(event) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    if (this.index + this.slidesValue < this.imageTargets.length) {
      this.index += 1;
      this.update();
    }
  }

  update() {
    if (!this.hasPrevTarget || !this.hasNextTarget) return;
    // Some thumbnails may not be materialized yet (lazy alternates), so the
    // arrows' visibility relies on the declared total rather than the DOM.
    const total = Math.max(this.hasTotalValue ? this.totalValue : 0, this.imageTargets.length);
    const windowStart = this.index;
    const windowEnd = this.index + this.slidesValue;

    // Show only images in the current window
    this.imageTargets.forEach((el, i) => {
      const inWindow = i >= windowStart && i < windowEnd;
      el.classList.toggle("tw:hidden", !inWindow);
    });

    // Show/hide arrows only if needed
    const needNav = total > this.slidesValue;
    this.toggleArrow(this.prevTarget, needNav);
    this.toggleArrow(this.nextTarget, needNav);

    // Disable arrows at bounds
    if (needNav) {
      const hasPrev = this.index !== 0;
      const hasNext = this.index + this.slidesValue < total;
      this.prevTarget.classList[!hasPrev ? "add" : "remove"]("tw:opacity-25");
      this.nextTarget.classList[!hasNext ? "add" : "remove"]("tw:opacity-25");

      this.prevTarget.classList[!hasPrev ? "add" : "remove"]("tw:pointer-events-none");
      this.nextTarget.classList[!hasNext ? "add" : "remove"]("tw:pointer-events-none");
    }
  }

  toggleArrow(arrowEl, show) {
    if (!arrowEl) return;
    arrowEl.classList.toggle("tw:hidden", !show);
  }
}
